import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { withRouter } from 'react-router-dom';
import menuRenderer from './menuRenderer';
import getOptionComponent from './FacetDropdownOption';
import _difference from 'lodash/difference';

const FacetDropdown = ({  facets, values, placeholder, changeValue, fieldName, history: { push }, groupLabel, base, selectedFacets,
  selectedMoreFilter, valueKey, clearable, locationBreadcrumb, className, labelKey, keywords, singleValue, changeValueOverride, inverseSelection, onOpen }) => {
  const options = {
    key: fieldName,
    groupLabel,
    facets,
    push,
    base,
    field: fieldName,
    locationBreadcrumb
  };
  const selected = selectedFacets.find( facet => facet.name === fieldName ) || {};
  if ((!values || !values.length) && selected.value ) {
    values.push({
      count: 0,
      facetItemPath: selected.value,
      label: `${selected.value} (0)`,
      level: 0,
      value: selected.value
    });
  }
  let selectedValue = ( selected.value && typeof selected.value === 'string' ) ? selected.value.split(':')[selected.value.split(':').length - 1] : '';
  if ( Array.isArray(selected.value) && selected.value.length ) {
    // of the value key is facetItemPath, it means the value we want to check is something like Europe:United Kingdom:London
    // therefore we want to keep the ":"
    if (valueKey === "facetItemPath") {
      selectedValue = selected.value.join(';');
    } else {
      selectedValue = selected.value.map( v => v.split(':').pop()).join(';');
    }
  }
  return (
      <Select
        options={values}
        simpleValue
        removeSelected={!!singleValue}
        multi={!singleValue}
        delimiter=";"
        closeOnSelect={!!singleValue}
        labelKey={labelKey || 'value'}
        valueKey={valueKey || 'value'}
        clearable={(typeof clearable === 'boolean' ) ? clearable : true}
        placeholder={placeholder}
        optionComponent={getOptionComponent({inverseSelection})}
        name="selected-state"
        className={'facet-select ' + className || ''}
        disabled={false}
        menuRenderer={menuRenderer}
        value={selectedMoreFilter || selectedValue}
        onChange={v => {
          let val = _difference(v.split(';'), selectedValue.split(';'));
          if (val.length && v !== '') {
            return (changeValueOverride) ? changeValueOverride(val) : changeValue(val[0], options, selected, keywords);
          }
          val = _difference(selectedValue.split(';'), v.split(';'));
          if (val.length) {
            return (changeValueOverride) ? changeValueOverride(val) : changeValue(val[0], options, selected, keywords, true);
          }
        }}
        onOpen={onOpen}
        openOnClick={true}
        onValueClick={() => {}}
        searchable={false} 
        />
  );
};

FacetDropdown.propTypes = {
  label: PropTypes.string,
  filter: PropTypes.string,
  singleValue: PropTypes.bool,
  value: PropTypes.string,
  keywords: PropTypes.string,
  className: PropTypes.string,
  clearable: PropTypes.bool,
  inverseSelection: PropTypes.bool,
  setFilter: PropTypes.func,
  selectedFacets: PropTypes.array,
  fieldName: PropTypes.string,
  groupLabel: PropTypes.string,
  selectedMoreFilter: PropTypes.string,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  placeholder: PropTypes.string,
  facets: PropTypes.object,
  values: PropTypes.array,
  changeValue: PropTypes.func,
  onOpen: PropTypes.func,
  changeValueOverride: PropTypes.func,
  remove: PropTypes.func,
  locationBreadcrumb: PropTypes.array,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  base: PropTypes.shape({
    pathname: PropTypes.string,
    qs: PropTypes.string
  }).isRequired
};

export const FacetDropdownSelect = withRouter(FacetDropdown);
